import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OrganizationSelection from '../components/auth/OrganizationSelection';
import { storageKeys } from '../config/environment';
import { useAuth } from '../contexts/AuthContext';

/**
 * Page de sélection d'organisation après authentification OAuth
 */
const OrganizationsSelection = () => {
    const navigate = useNavigate();
    const { selectOrganization } = useAuth();
    const [user, setUser] = useState(null);
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        // Récupérer les données depuis localStorage
        const savedUser = JSON.parse(localStorage.getItem(storageKeys.user) || '{}');
        const savedOrganizations = JSON.parse(localStorage.getItem(storageKeys.organizations) || '[]');

        if (!savedUser.id || savedOrganizations.length === 0) {
            // Si pas de données, rediriger vers la connexion
            navigate('/');
            return;
        }

        setUser(savedUser);
        setOrganizations(savedOrganizations);
    }, [navigate]);

    const handleOrganizationSelect = (organizationId, role) => {
        console.log('[OrganizationsSelection] Sélection d\'organisation:', {
            organizationId,
            role,
            organizationsAvailable: organizations.length
        });

        // Trouver l'organisation dans la liste locale
        const org = organizations.find(o => o.id === organizationId);
        
        console.log('[OrganizationsSelection] Organisation trouvée:', {
            found: !!org,
            orgData: org ? {
                id: org.id,
                name: org.name,
                role: org.role,
                roles: org.roles,
                current_user_roles: org.current_user_roles
            } : null,
            selectedRole: role
        });

        if (org) {
            // Passer l'organisation directement pour éviter les problèmes de synchronisation
            selectOrganization(organizationId, role, org);
        } else {
            console.warn('[OrganizationsSelection] Organisation non trouvée localement, utilisation de l\'ID seulement');
            // Si pas trouvé localement, essayer quand même avec juste l'ID
            selectOrganization(organizationId, role);
        }
    };

    const handleBack = () => {
        // Déconnexion et retour à la page de login
        localStorage.clear();
        navigate('/');
    };

    if (!user || organizations.length === 0) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-white mx-auto mb-4"></div>
                    <p className="text-white font-semibold text-lg">Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <OrganizationSelection
            user={{
                username: user.username || user.name || '',
                organizations: organizations
            }}
            onOrganizationSelect={handleOrganizationSelect}
            onBack={handleBack}
        />
    );
};

export default OrganizationsSelection;


